import FilterPanel, { type FilterValue } from "@/components/feature/FilterPanel";
import { categories } from "@/mocks/categories";

interface FilterDrawerProps {
  open: boolean;
  value: FilterValue;
  onClose: () => void;
  onApply: (value: FilterValue) => void;
  onChange: (value: FilterValue) => void;
  onReset: () => void;
  showGenre?: boolean;
}

export default function FilterDrawer({
  open,
  value,
  onClose,
  onApply,
  onChange,
  onReset,
  showGenre = true,
}: FilterDrawerProps) {
  return (
    <div className={`lg:hidden fixed inset-0 z-50 ${open ? "" : "pointer-events-none"}`} aria-hidden={!open}>
      <div
        onClick={onClose}
        className={`absolute inset-0 bg-foreground-950/45 transition-opacity duration-300 ${
          open ? "opacity-100" : "opacity-0"
        }`}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="筛选条件"
        className={`absolute inset-x-0 bottom-0 max-h-[82vh] overflow-y-auto rounded-t-2xl bg-background-50 transition-transform duration-300 ${
          open ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div className="sticky top-0 bg-background-50 px-4 pt-3 pb-2 border-b border-background-200">
          <div className="mx-auto w-10 h-1 rounded-full bg-background-300" />
          <div className="mt-3 flex items-center justify-between">
            <h2 className="font-heading text-base font-bold text-foreground-950">筛选条件</h2>
            <button
              type="button"
              onClick={onClose}
              aria-label="关闭筛选"
              className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 cursor-pointer"
            >
              <i className="ri-close-line" />
            </button>
          </div>
        </div>
        <div className="px-4 py-4">
          <FilterPanel
            value={value}
            onChange={onChange}
            hideGenre={!showGenre}
            genreOptions={categories.map((cat) => ({ label: cat.name, value: cat.name }))}
          />
        </div>
        <div className="sticky bottom-0 bg-background-50 border-t border-background-200 px-4 py-3 flex items-center gap-2">
          <button
            type="button"
            onClick={onReset}
            className="h-10 flex-1 rounded-md border border-background-300 text-[13px] text-foreground-700 cursor-pointer whitespace-nowrap"
          >
            清除筛选
          </button>
          <button
            type="button"
            onClick={() => onApply(value)}
            className="h-10 flex-[1.6] rounded-md bg-primary-500 text-background-50 text-[13px] font-medium cursor-pointer whitespace-nowrap"
          >
            查看结果
          </button>
        </div>
      </div>
    </div>
  );
}